import React, { useContext } from 'react'
import Table, { Header, Row, Cell } from '../../../../../components/Table'
import { getMessage } from '../../../../../lib/translator'
import { Dialog } from '../../../../../components/Popup'
import {
  BaseForm,
  MultiTextInput,
  VALIDATION_TYPES,
} from '../../../../../components/Form'
import _ from 'lodash'
import { SplitContext } from 'containers/SplitContext'
import SPLIT_FEATURES from 'containers/SplitContext/features'
import { tags } from '../PacklistView'
import './style.scss'

const validLabelWithoutZonePrefix = new RegExp(/^([A|B|C|F|W]-\d+|DB-\d{2,})$/)

const packlistOwnerType = {
  vendor: 'PACKLIST_OWNER_TYPE_VENDOR',
  store: 'PACKLIST_OWNER_TYPE_STORE',
}

class PacklistPackingDetails extends BaseForm {
  constructor(props) {
    super(props)
    this.getPackageName = this.getPackageName.bind(this)
    this.getPackageArray = this.getPackageArray.bind(this)
    this.getPacklistId = this.getPacklistId.bind(this)
  }

  initializePacklistPackages = () => {
    const packlistPackages = {}
    ;(this.props.packlistDetails || []).forEach((packlist) => {
      packlistPackages[this.getPacklistId(packlist)] = this.getPackageArray(
        packlist.packages
      )
    })

    this.notifiedPackages = null
    this.setState({
      values: {
        ...(this.state.values || {}),
        packlistPackages,
        original: JSON.parse(JSON.stringify(packlistPackages)),
      },
      invalidLabel: false,
    })
  }

  componentDidMount() {
    if (this.props.itemEditMode) {
      this.initializePacklistPackages()
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.itemEditMode && !prevProps.itemEditMode) {
      this.initializePacklistPackages()
      return
    }

    if (!this.props.itemEditMode || this.state.invalidLabel) {
      return
    }

    const packlistPackages = this.getState(['packlistPackages'])
    const original = this.getState(['original'])

    if (_.isEqual(packlistPackages, original)) {
      return
    }

    // This also runs when the parent re-renders after storing the edit, so only
    // report values we have not reported yet; otherwise the two components keep
    // triggering each other's updates.
    if (_.isEqual(packlistPackages, this.notifiedPackages)) {
      return
    }

    this.notifiedPackages = _.cloneDeep(packlistPackages)
    this.props.updateCrates(packlistPackages, original)
  }

  formatLabelChanges = (event, packlist) => {
    const prevEvent =
      this.getState(['packlistPackages', this.getPacklistId(packlist)]) || []
    const nextEvent = Array.isArray(event) ? event : []

    if (prevEvent.length > nextEvent.length) {
      return nextEvent
    }

    if (nextEvent.length > 0) {
      if (
        this.props.zonePrefix[packlist.tag] &&
        packlist.ownerType === packlistOwnerType.store
      ) {
        if (!validLabelWithoutZonePrefix.test(nextEvent[nextEvent.length - 1])) {
          this.setState({
            invalidLabel: true,
          })
          nextEvent.pop()
          return nextEvent
        } else {
          nextEvent[nextEvent.length - 1] =
            `${this.props.zonePrefix[packlist.tag]}-${nextEvent[nextEvent.length - 1]}`
        }
      }
    }

    return nextEvent
  }

  resetWrongLabel = () => {
    this.setState({
      invalidLabel: false,
    })
  }

  getPacklistTitle = (packlist) => {
    if (packlist.tag === 'all' && packlist.ownerType && packlist.ownerName) {
      return packlist.ownerType === packlistOwnerType.vendor
        ? packlist.ownerName
        : tags[packlist.tag]
    }
    return tags[packlist.tag]
  }

  getPackageName = (packages) => {
    return (packages || []).map((pack) => pack.packageCode).join(', ')
  }

  getPackageArray = (packages) => {
    return (packages || [])
      .map((pack) => pack && pack.packageCode)
      .filter(Boolean)
  }

  getPacklistId = (packlist) => {
    return packlist != null ? packlist.id : null
  }

  render() {
    const { itemEditMode, packlistDetails } = this.props
    const hasPackages = (packlistDetails || []).some(
      (packlist) =>
        Array.isArray(packlist.packages) && packlist.packages.length > 0
    )

    if (!itemEditMode && !hasPackages) {
      return (
        <div className="packing-details" data-testid="packing-details">
          <h3>{getMessage('order.details.packing.heading')}</h3>
          <p
            className="packing-details__empty"
            data-testid="packing-details-empty"
          >
            {getMessage('order.details.packing.empty')}
          </p>
        </div>
      )
    }

    return (
      <div className="packing-details" data-testid="packing-details">
        <h3>{getMessage('order.details.packing.heading')}</h3>
        <Table>
          <Header>
            <Cell>{getMessage('order.packing.type')}</Cell>
            <Cell></Cell>
            <Cell>{getMessage('order.packing.labels')}</Cell>
          </Header>
          {packlistDetails.map((packlist, packlistindex) => {
            return (
              <React.Fragment key={`packing-item-${packlistindex}`}>
                {itemEditMode ? (
                  <>
                    <Row>
                      <Cell>
                        {' '}
                        <b>{this.getPacklistTitle(packlist)}</b> (Packlist id:{' '}
                        {packlist.id})
                      </Cell>
                      <Cell></Cell>
                      <Cell></Cell>
                    </Row>
                    <Row key={`packing-item-${packlistindex}2`}></Row>
                    <Cell> Crates </Cell>
                    <Cell className="zone-prefix" align="right">
                      {this.props.zonePrefix[packlist.tag] &&
                      packlist.ownerType === packlistOwnerType.store
                        ? this.props.zonePrefix[packlist.tag] + ' - '
                        : ''}
                    </Cell>
                    <Cell>
                      <MultiTextInput
                        placeholder={getMessage(
                          'order.details.packages.multi-text.placeholder'
                        )}
                        name={`packages-crates`}
                        classname="packages"
                        value={
                          this.state.values['packlistPackages']
                            ? [this.getPacklistId(packlist)]
                            : []
                        }
                        {...this.generateStateMappers({
                          stateKeys: [
                            'packlistPackages',
                            this.getPacklistId(packlist),
                          ],
                          validationType: VALIDATION_TYPES.ONS,
                          formatChange: (event) =>
                            this.formatLabelChanges(event, packlist),
                        })}
                      />
                    </Cell>
                    <Dialog
                      title={getMessage('order.details.packlist.invalidLabel')}
                      show={this.state.invalidLabel}
                      close={this.resetWrongLabel}
                      closeText={getMessage(
                        'order.details.edit-packed.error.closeDialog'
                      )}
                    />
                  </>
                ) : (
                  <>
                    {(packlist.packages || []).length === 0 ? null : (
                      <>
                        <Row>
                          <Cell>
                            <b>{this.getPacklistTitle(packlist)}</b>
                            &nbsp;
                            <span style={{ color: '#80959d' }}>
                              (Packlist id: {packlist.id})
                            </span>
                          </Cell>
                          <Cell></Cell>
                          <Cell></Cell>
                        </Row>
                        <Row key={`packing-item-${packlistindex}2`}></Row>
                        <Cell> Crates </Cell>
                        <Cell></Cell>
                        <Cell>{this.getPackageName(packlist.packages)}</Cell>
                      </>
                    )}
                  </>
                )}
              </React.Fragment>
            )
          })}
          <footer></footer>
        </Table>
      </div>
    )
  }
}

const PacklistPackingDetailsWrapper = (props) => {
  const splitConfig = useContext(SplitContext)
  const { splits } = splitConfig

  const zonePrefix = splits?.[SPLIT_FEATURES.ZONE_PREFIX_LABEL]
    ? JSON.parse(splits[SPLIT_FEATURES.ZONE_PREFIX_LABEL].config)
    : {}

  return <PacklistPackingDetails zonePrefix={zonePrefix} {...props} />
}

export default PacklistPackingDetailsWrapper
